module.exports = __webpack_public_path__ + "static/media/twitter.ed776b07.svg";